// individual kind handler start

import { useFormikContext } from "formik";
import { useEffect } from "react";
import { customerKindEnum, customerTypeEnum } from "../../../utils";

export const IndividualHandler = () => {
  const { values, setFieldValue }: any = useFormikContext();
  const { customerTypeId, customerKindId } = values;

  /* useEffect(() => {
    if (
      customerTypeId === customerTypeEnum.real &&
      customerKindId !== customerKindEnum.corporate
    ) {
      setFieldValue("contact.isAuthorizedSignature", true, false);
      setFieldValue("contact.isAuthorizedPerson", true, false);
    } else {
      setFieldValue("contact.isAuthorizedSignature", false, false);
      setFieldValue("contact.isAuthorizedPerson", false, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerTypeId, customerKindId]);
 */
  return null;
};
// individual kind handler end
export default IndividualHandler;
